import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, guardReactiveProps as u, isRef as d, normalizeClass as f, normalizeProps as p, onErrorCaptured as m, onMounted as ee, openBlock as h, ref as te, renderList as ne, renderSlot as g, toDisplayString as _, unref as v, useSlots as re, watch as ie, withCtx as y, withModifiers as ae } from "vue";
import { Button as oe, Checkbox as se, CheckboxGroup as ce, CurrencyInput as le, DatePicker as ue, FormRow as b, Label as x, LabelPosition as de, MultiSelectWithBadges as fe, NestedTranslation as pe, NumberInput as me, PopOver as S, RadioGroup as he, SearchSuggestTextInput as ge, Select as _e, SelectAutocomplete as ve, Switch as ye, TextArea as be, TextInput as xe, TextInputWithButton as Se, WeightSelector as Ce } from "@myparcel-frontend/ui";
import { useField as C, useFieldArray as we, useForm as Te } from "vee-validate";
import { useI18n as w } from "vue-i18n";
import { preventFloatyValues as Ee, regex as De } from "@myparcel-frontend/utils";
import { z as Oe } from "zod";
//#region \0plugin-vue:export-helper
var ke = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Ae = {}, je = {
	class: "pl-3 text-red text-sm",
	role: "status"
};
function Me(e, t) {
	return h(), i("p", je, [g(e.$slots, "default")]);
}
var T = /*#__PURE__*/ ke(Ae, [["render", Me]]), Ne = ["aria-label"], Pe = /* @__PURE__ */ l({
	__name: "Form",
	props: { ariaLabel: { default: "form" } },
	emits: ["submit"],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (h(), i("form", {
			"aria-label": e.ariaLabel,
			novalidate: "",
			onSubmit: r[0] ||= ae((e) => n("submit"), ["prevent"])
		}, [g(t.$slots, "default")], 40, Ne));
	}
}), Fe = { class: "text-gray-500" }, Ie = /* @__PURE__ */ l({
	__name: "CheckboxField",
	props: {
		name: {},
		disabled: { type: Boolean },
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	setup(e) {
		let t = e, r = w(), { value: i, errorMessage: l } = C(() => t.name);
		return (t, u) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(se), {
				modelValue: v(i),
				"onUpdate:modelValue": u[0] ||= (e) => d(i) ? i.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(l) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name
			}, {
				default: y(() => [g(t.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"aria-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"name"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", Fe, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(l) && v(l).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(r).te(v(l)) ? v(r).t(v(l)) : v(l)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), Le = { class: "text-gray-900" }, Re = /* @__PURE__ */ l({
	__name: "CheckboxGroupField",
	props: {
		name: {},
		modelValue: { default: void 0 },
		disabled: { type: Boolean },
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		options: {},
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: f, errorMessage: m } = C(() => r.name);
		return ie(() => r.modelValue, (e) => {
			e !== void 0 && JSON.stringify(e) !== JSON.stringify(f.value) && (f.value = e);
		}, { immediate: !0 }), ie(f, (e) => {
			i("update:modelValue", e ?? []);
		}, { deep: !0 }), (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(ce), {
				modelValue: v(f),
				"onUpdate:modelValue": r[0] ||= (e) => d(f) ? f.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(m) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name,
				options: e.options
			}, {
				icon: y((e) => [g(t.$slots, "icon", p(u(e)))]),
				_: 3
			}, 8, [
				"modelValue",
				"aria-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"name",
				"options"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", Le, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(m) && v(m).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(m)) ? v(l).t(v(m)) : v(m)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), ze = { class: "flex flex-col gap-y-2 grow" }, Be = /* @__PURE__ */ l({
	__name: "CurrencyInputField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		isDisabled: { type: Boolean },
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		emptyValue: { default: void 0 }
	},
	emits: ["blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: d, setValue: f, handleBlur: p } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), m = (e) => {
			f(e, !0);
		}, ee = (e) => {
			i("blur", e), p(e, !0);
		};
		return (t, i) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [a("div", ze, [c(v(le), {
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.isDisabled,
				"empty-value": r.emptyValue,
				"is-valid": v(d) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				"model-value": v(u),
				name: e.name,
				placeholder: e.placeholder,
				"wrapper-class": "w-full",
				onBlur: i[0] ||= (e) => ee(e),
				"onUpdate:modelValue": m
			}, null, 8, [
				"aria-label",
				"disabled",
				"empty-value",
				"is-valid",
				"labelled-by",
				"model-value",
				"name",
				"placeholder"
			]), g(t.$slots, "hint")])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [c(v(pe), { translation: e.note }, null, 8, ["translation"])]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(d) && v(d).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(d)) ? v(l).t(v(d)) : v(d)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), Ve = /* @__PURE__ */ l({
	__name: "DateField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		maxDate: { default: void 0 }
	},
	setup(e) {
		let t = e, { value: r, errorMessage: i } = C(() => t.name);
		return (t, a) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(ue), {
				modelValue: v(r),
				"onUpdate:modelValue": a[0] ||= (e) => d(r) ? r.value = e : null,
				"aria-labels": { input: e.label },
				"is-valid": v(i) == null,
				"max-date": e.maxDate,
				name: e.name,
				placeholder: e.placeholder
			}, null, 8, [
				"modelValue",
				"aria-labels",
				"is-valid",
				"max-date",
				"name",
				"placeholder"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(i) && v(i).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(i)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), He = { class: "flex flex-col grow-1" }, Ue = {
	key: 0,
	class: "text-gray-900 text-sm mt-2 pl-3"
}, We = /* @__PURE__ */ l({
	__name: "DimensionProperty",
	props: {
		name: {},
		label: {},
		parentPath: {},
		physicalProperty: {},
		placeholder: {}
	},
	setup(e) {
		let t = e, { t: a } = w(), { value: o, errorMessage: l } = C(() => `${t.parentPath}.${t.name}`, void 0, { validateOnValueUpdate: !0 });
		return (t, u) => (h(), i("div", He, [
			c(v(me), {
				modelValue: v(o),
				"onUpdate:modelValue": u[0] ||= (e) => d(o) ? o.value = e : null,
				"aria-label": e.label,
				"is-valid": v(l) == null,
				name: `${e.parentPath}.${e.name}`,
				placeholder: e.placeholder,
				onBeforeinput: v(Ee)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"is-valid",
				"name",
				"placeholder",
				"onBeforeinput"
			]),
			e.physicalProperty ? (h(), i("p", Ue, _(v(a)(`ui.fields.${e.name}.minMax`, {
				min: e.physicalProperty.min,
				max: e.physicalProperty.max
			})), 1)) : r("", !0),
			v(l) && v(l).trim() ? (h(), n(T, { key: 1 }, {
				default: y(() => [s(_(v(a)(v(l))), 1)]),
				_: 1
			})) : r("", !0)
		]));
	}
}), Ge = { class: "flex flex-row items-start grow-1" }, Ke = /*#__PURE__*/ ke(/* @__PURE__ */ l({
	__name: "DimensionsField",
	props: {
		physicalProperties: {},
		parentPath: {},
		hideLabel: { type: Boolean },
		preserveLabelGap: { type: Boolean },
		labelPosition: {}
	},
	setup(e) {
		let { t } = w();
		return (r, i) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"label-position": e.labelPosition,
			"preserve-label-gap": e.preserveLabelGap
		}, {
			label: y(() => [g(r.$slots, "label", {}, void 0, !0)]),
			note: y(() => [g(r.$slots, "note", {}, void 0, !0)]),
			default: y(() => [a("div", Ge, [
				c(We, {
					class: "dimension-property",
					label: v(t)("ui.fields.length.label"),
					name: "length",
					"parent-path": e.parentPath,
					"physical-property": e.physicalProperties.length,
					placeholder: v(t)("ui.fields.length.placeholder")
				}, null, 8, [
					"label",
					"parent-path",
					"physical-property",
					"placeholder"
				]),
				c(We, {
					class: "dimension-property",
					label: v(t)("ui.fields.width.label"),
					name: "width",
					"parent-path": e.parentPath,
					"physical-property": e.physicalProperties.width,
					placeholder: v(t)("ui.fields.width.placeholder")
				}, null, 8, [
					"label",
					"parent-path",
					"physical-property",
					"placeholder"
				]),
				c(We, {
					class: "dimension-property",
					label: v(t)("ui.fields.height.label"),
					name: "height",
					"parent-path": e.parentPath,
					"physical-property": e.physicalProperties.height,
					placeholder: v(t)("ui.fields.height.placeholder")
				}, null, 8, [
					"label",
					"parent-path",
					"physical-property",
					"placeholder"
				])
			])]),
			_: 3
		}, 8, [
			"hide-label",
			"label-position",
			"preserve-label-gap"
		]));
	}
}), [["__scopeId", "data-v-893a688a"]]), qe = { class: "text-gray-500" }, Je = { class: "flex gap-4 w-full" }, Ye = /* @__PURE__ */ l({
	__name: "FieldGroup",
	props: {
		label: {},
		sublabel: {},
		hideLabel: { type: Boolean }
	},
	setup(e) {
		let t = re();
		return (i, l) => (h(), n(v(b), null, o({
			label: y(() => [e.hideLabel ? r("", !0) : (h(), n(v(x), { key: 0 }, o({
				default: y(() => [s(_(e.label) + " ", 1)]),
				_: 2
			}, [e.sublabel ? {
				name: "sublabel",
				fn: y(() => [a("span", qe, _(e.sublabel), 1)]),
				key: "0"
			} : void 0]), 1024))]),
			default: y(() => [a("div", Je, [g(i.$slots, "default")])]),
			_: 2
		}, [t.note ? {
			name: "note",
			fn: y(() => [c(v(S), null, {
				default: y(() => [g(i.$slots, "note")]),
				_: 3
			})]),
			key: "0"
		} : void 0]), 1024));
	}
}), Xe = { class: "text-gray-500" }, Ze = /* @__PURE__ */ l({
	__name: "MultiSelectWithBadgesField",
	props: {
		name: {},
		disabled: { type: Boolean },
		options: {},
		labelPosition: { default: "left" },
		modelValue: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f } = C(() => r.name, void 0, { validateOnValueUpdate: !1 });
		return ie(() => r.modelValue, (e) => {
			e !== void 0 && JSON.stringify(e) !== JSON.stringify(u.value) && (u.value = e);
		}, { immediate: !0 }), ie(u, (e) => {
			i("update:modelValue", e);
		}, { deep: !0 }), (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"label-position": e.labelPosition,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(fe), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				label: e.hideLabel ? e.label : "",
				"labelled-by": e.hideLabel ? "" : e.name,
				name: e.name,
				options: e.options
			}, null, 8, [
				"modelValue",
				"disabled",
				"is-valid",
				"label",
				"labelled-by",
				"name",
				"options"
			])]),
			_: 2
		}, [e.hideLabel ? void 0 : {
			name: "label",
			fn: y(() => [c(v(x), { id: e.name }, o({
				default: y(() => [s(_(e.label) + " ", 1)]),
				_: 2
			}, [e.sublabel ? {
				name: "sublabel",
				fn: y(() => [a("span", Xe, _(e.sublabel), 1)]),
				key: "0"
			} : void 0]), 1032, ["id"])]),
			key: "0"
		}, v(f) && v(f).trim() ? {
			name: "errors",
			fn: y(() => [c(T, null, {
				default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
				_: 1
			})]),
			key: "1"
		} : void 0]), 1032, [
			"hide-label",
			"label-position",
			"preserve-label-gap"
		]));
	}
}), Qe = { class: "flex flex-col gap-y-2 grow" }, $e = /* @__PURE__ */ l({
	__name: "NumberInputField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f, handleBlur: p } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), m = (e) => {
			i("blur", e), p(e, !0);
		};
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [a("div", Qe, [c(v(me), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				name: e.name,
				placeholder: e.placeholder,
				onBlur: r[1] ||= (e) => m(e)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"disabled",
				"is-valid",
				"name",
				"placeholder"
			]), g(t.$slots, "hint")])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(f) && v(f).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), et = { class: "text-gray-500" }, tt = /* @__PURE__ */ l({
	__name: "RadioGroupField",
	props: {
		name: {},
		label: {},
		options: {},
		optionIdentifier: { default: void 0 },
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		alignment: { default: "vertical" },
		radioClass: { default: void 0 },
		activeClass: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	setup(e) {
		let t = e, r = re(), i = w(), { value: l, errorMessage: u } = C(() => t.name);
		return (t, f) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [e.options.length ? (h(), n(v(he), {
				key: 0,
				modelValue: v(l),
				"onUpdate:modelValue": f[0] ||= (e) => d(l) ? l.value = e : null,
				"active-class": e.activeClass,
				alignment: e.alignment,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(u) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name,
				"option-identifier": e.optionIdentifier,
				options: e.options,
				"radio-class": e.radioClass
			}, {
				icon: y(({ option: e }) => [g(t.$slots, "icon", { option: e })]),
				label: y(({ option: e }) => [g(t.$slots, "label", { option: e })]),
				_: 3
			}, 8, [
				"modelValue",
				"active-class",
				"alignment",
				"aria-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"name",
				"option-identifier",
				"options",
				"radio-class"
			])) : g(t.$slots, "empty", {}, void 0, void 0, 1)]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", et, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			r.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [g(t.$slots, "note")]),
					_: 3
				})]),
				key: "1"
			} : void 0,
			v(u) && v(u).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(i).te(v(u)) ? v(i).t(v(u)) : v(u)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), nt = { class: "text-gray-500" }, rt = /* @__PURE__ */ l({
	__name: "SearchSuggestTextInputField",
	props: {
		name: {},
		label: {},
		suggestions: {},
		placeholder: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		maxLength: { default: void 0 },
		buttonVariant: { default: "secondary" },
		cancelLabel: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	emits: [
		"blur",
		"search",
		"selected"
	],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f, handleBlur: p } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), m = (e) => {
			i("blur", e), p(void 0, !0);
		};
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(ge), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				"button-variant": e.buttonVariant,
				"cancel-label": e.cancelLabel,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				"max-length": e.maxLength,
				name: e.name,
				placeholder: e.placeholder,
				suggestions: e.suggestions,
				onBlur: m,
				onSearch: r[1] ||= (e) => i("search", v(u)),
				onSelected: r[2] ||= (e) => i("selected", e)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"button-variant",
				"cancel-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"max-length",
				"name",
				"placeholder",
				"suggestions"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", nt, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(f) && v(f).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), it = { class: "text-gray-500" }, at = /* @__PURE__ */ l({
	__name: "SelectAutocompleteField",
	props: {
		name: {},
		label: {},
		options: {},
		placeholder: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		disabled: { type: Boolean },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		labelPosition: { default: de.Right }
	},
	setup(e) {
		let t = e, r = w(), { value: i, errorMessage: l } = C(() => t.name);
		return (t, u) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"label-position": e.labelPosition,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(ve), {
				modelValue: v(i),
				"onUpdate:modelValue": u[0] ||= (e) => d(i) ? i.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(l) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name,
				options: e.options,
				placeholder: e.placeholder
			}, null, 8, [
				"modelValue",
				"aria-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"name",
				"options",
				"placeholder"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", it, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(l) && v(l).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(r).te(v(l)) ? v(r).t(v(l)) : v(l)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, [
			"hide-label",
			"label-position",
			"preserve-label-gap"
		]));
	}
}), ot = { class: "text-gray-900" }, st = /* @__PURE__ */ l({
	__name: "SelectField",
	props: {
		name: {},
		label: {},
		options: {},
		placeholder: { default: void 0 },
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f } = C(() => r.name, void 0, { validateOnValueUpdate: !1 });
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(_e), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name,
				options: e.options,
				placeholder: e.placeholder,
				onBlur: r[1] ||= (e) => i("blur", e)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"disabled",
				"is-valid",
				"labelled-by",
				"name",
				"options",
				"placeholder"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { id: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [a("span", ot, _(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["id"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(f) && v(f).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), ct = { class: "flex flex-col gap-y-2 grow" }, lt = /* @__PURE__ */ l({
	__name: "SwitchField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		disabled: {
			type: Boolean,
			default: !1
		},
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		labelPosition: { default: void 0 }
	},
	setup(e) {
		let t = e, r = w(), { value: i, errorMessage: l } = C(() => t.name);
		return (t, u) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"label-position": e.labelPosition,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [a("div", ct, [a("div", { class: f({ "flex items-center lg:h-[42px]": e.labelPosition !== v(de).Top }) }, [c(v(ye), {
				modelValue: v(i),
				"onUpdate:modelValue": u[0] ||= (e) => d(i) ? i.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				"labelled-by": e.hideLabel ? void 0 : e.name,
				name: e.name,
				placeholder: e.placeholder
			}, null, 8, [
				"modelValue",
				"aria-label",
				"labelled-by",
				"name",
				"placeholder"
			])], 2), g(t.$slots, "hint", { value: v(i) })])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(l) ? {
				name: "errors",
				fn: y(() => [c(T, { class: "pl-0!" }, {
					default: y(() => [s(_(v(r).te(v(l)) ? v(r).t(v(l)) : v(l)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, [
			"hide-label",
			"label-position",
			"preserve-label-gap"
		]));
	}
}), ut = /* @__PURE__ */ l({
	__name: "TextAreaField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		rows: { default: void 0 },
		cols: { default: void 0 }
	},
	emits: ["blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, a = w(), { value: l, errorMessage: u, handleBlur: f } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), p = (e) => {
			i("blur", e), f(e, !0);
		};
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [c(v(be), {
				modelValue: v(l),
				"onUpdate:modelValue": r[0] ||= (e) => d(l) ? l.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				cols: e.cols,
				"is-valid": v(u) == null,
				name: e.name,
				placeholder: e.placeholder,
				rows: e.rows,
				onBlur: p
			}, null, 8, [
				"modelValue",
				"aria-label",
				"cols",
				"is-valid",
				"name",
				"placeholder",
				"rows"
			])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(u) && v(u).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(a).te(v(u)) ? v(a).t(v(u)) : v(u)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), dt = { class: "flex flex-col gap-y-2 grow" }, ft = /* @__PURE__ */ l({
	__name: "TextInputField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		labelPosition: { default: de.Right },
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		type: { default: "text" },
		autoFocus: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f, handleBlur: p } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), m = (e) => {
			i("blur", e), p(e, !0);
		};
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"label-position": e.labelPosition,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [a("div", dt, [c(v(xe), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				"auto-focus": e.autoFocus,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				name: e.name,
				placeholder: e.placeholder,
				type: e.type,
				onBlur: r[1] ||= (e) => m(e)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"auto-focus",
				"disabled",
				"is-valid",
				"name",
				"placeholder",
				"type"
			]), g(t.$slots, "hint")])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(f) && v(f).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, [
			"hide-label",
			"label-position",
			"preserve-label-gap"
		]));
	}
}), pt = { class: "flex flex-col gap-y-2 grow" }, mt = /* @__PURE__ */ l({
	__name: "TextInputWithButtonField",
	props: {
		name: {},
		label: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		type: { default: void 0 },
		buttonVariant: { default: "secondary-outline" },
		buttonDisabled: { type: Boolean },
		buttonAriaLabel: { default: void 0 },
		buttonClass: { default: void 0 },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["blur", "click"],
	setup(e, { emit: t }) {
		let r = e, i = t, l = w(), { value: u, errorMessage: f, handleBlur: p } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), m = (e) => {
			i("blur", e), p(e, !0);
		};
		return (t, r) => (h(), n(v(b), {
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, o({
			default: y(() => [a("div", pt, [c(v(Se), {
				modelValue: v(u),
				"onUpdate:modelValue": r[0] ||= (e) => d(u) ? u.value = e : null,
				"aria-label": e.hideLabel ? e.label : void 0,
				"button-aria-label": e.buttonAriaLabel,
				"button-class": e.buttonClass,
				"button-disabled": e.buttonDisabled,
				"button-variant": e.buttonVariant,
				disabled: e.disabled,
				"is-valid": v(f) == null,
				name: e.name,
				placeholder: e.placeholder,
				onBlur: r[1] ||= (e) => m(e),
				onClick: r[2] ||= (e) => t.$emit("click", e)
			}, {
				button: y(() => [g(t.$slots, "button")]),
				_: 3
			}, 8, [
				"modelValue",
				"aria-label",
				"button-aria-label",
				"button-class",
				"button-disabled",
				"button-variant",
				"disabled",
				"is-valid",
				"name",
				"placeholder"
			]), g(t.$slots, "hint")])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(f) && v(f).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(l).te(v(f)) ? v(l).t(v(f)) : v(f)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), ht = { class: "flex flex-col gap-y-2 grow" }, gt = /* @__PURE__ */ l({
	__name: "TextInputWithButtonFieldArray",
	props: {
		name: {},
		label: {},
		hideExtraLabels: { type: Boolean },
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		type: { default: void 0 },
		showAddButton: {
			type: Boolean,
			default: !0
		},
		buttonVariant: { default: "secondary-outline" },
		buttonDisabled: { type: Boolean },
		buttonAriaLabel: { default: void 0 },
		buttonClass: { default: void 0 },
		maxFields: { default: 5 },
		fieldCount: { default: 1 },
		labelFormatter: {
			type: Function,
			default: void 0
		}
	},
	setup(o) {
		let s = o, l = we(() => s.name), { fields: u } = l, d = t(() => u.value.length < s.maxFields), f = t(() => u.value.map((e, t) => t === 0 ? s.label : s.labelFormatter ? s.labelFormatter(t) : `${s.label} ${t + 1}`));
		return ee(() => {
			for (let e = u.value.length; e < s.fieldCount; e++) l.push("");
		}), (t, p) => (h(), i(e, null, [(h(!0), i(e, null, ne(v(u), (e, r) => (h(), i("div", { key: e.key }, [r !== v(u).length - 1 || r === 0 ? (h(), n(ft, {
			key: 0,
			class: "mb-2",
			"hide-label": r > 0 && o.hideExtraLabels,
			label: f.value[r],
			name: `${s.name}[${r}]`,
			note: r === 0 && o.note ? o.note : void 0,
			placeholder: r > 0 && o.hideExtraLabels ? f.value[r] : o.placeholder,
			sublabel: r === 0 && o.sublabel ? o.sublabel : void 0
		}, null, 8, [
			"hide-label",
			"label",
			"name",
			"note",
			"placeholder",
			"sublabel"
		])) : (h(), n(mt, {
			key: 1,
			"button-aria-label": o.buttonAriaLabel,
			"button-class": o.buttonClass,
			"button-disabled": o.buttonDisabled,
			"button-variant": o.buttonVariant,
			class: "mb-2",
			"hide-label": r > 0 && o.hideExtraLabels,
			label: f.value[r],
			name: `${s.name}[${r}]`,
			placeholder: r > 0 && o.hideExtraLabels ? f.value[r] : o.placeholder,
			type: o.type,
			onClick: (e) => v(l).remove(r)
		}, {
			button: y(() => [g(t.$slots, "fieldButton")]),
			_: 3
		}, 8, [
			"button-aria-label",
			"button-class",
			"button-disabled",
			"button-variant",
			"hide-label",
			"label",
			"name",
			"placeholder",
			"type",
			"onClick"
		]))]))), 128)), o.showAddButton && d.value ? (h(), n(v(b), { key: 0 }, {
			default: y(() => [a("div", ht, [g(t.$slots, "hint"), c(v(oe), {
				class: "inline-flex items-center gap-1 p-0 grow-0",
				variant: "secondary-basic",
				onClick: p[0] ||= (e) => v(l).push("")
			}, {
				default: y(() => [g(t.$slots, "addButton")]),
				_: 3
			})])]),
			_: 3
		})) : r("", !0)], 64));
	}
}), E = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, D = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
E.Dhl, E.Instabox, E.PostNl, D.PostNl, E.Bpost, D.Bpost, E.CheapCargo, D.CheapCargo, E.Dpd, D.Dpd, E.Instabox, D.Instabox, E.Dhl, D.Dhl, E.Bol, D.Bol, E.Ups, D.Ups, E.DhlForYou, D.DhlForYou, E.DhlParcelConnect, D.DhlParcelConnect, E.DhlEuroPlus, D.DhlEuroPlus, E.UpsStandard, D.UpsStandard, E.UpsExpressSaver, D.UpsExpressSaver, E.Gls, D.Gls, E.Brt, D.Brt, E.Trunkrs, D.Trunkrs, E.InPost, D.InPost, E.PosteItaliane, D.PosteItaliane, E.Spring, D.Spring, E.ViaTim, D.ViaTim, E.PostNl, D.POSTNL, E.Bpost, D.BPOST, E.CheapCargo, D.CHEAP_CARGO, E.Dpd, D.DPD, E.Instabox, D.INSTABOX, E.Dhl, D.DHL, E.Bol, D.BOL, E.Ups, D.UPS, E.DhlForYou, D.DHL_FOR_YOU, E.DhlParcelConnect, D.DHL_PARCEL_CONNECT, E.DhlEuroPlus, D.DHL_EUROPLUS, E.UpsStandard, D.UPS_STANDARD, E.UpsExpressSaver, D.UPS_EXPRESS_SAVER, E.Gls, D.GLS, E.Brt, D.BRT, E.Trunkrs, D.TRUNKRS, E.InPost, D.INPOST, E.PosteItaliane, D.POSTE_ITALIANE, E.Spring, D.SPRING, E.ViaTim, D.VIA_TIM, D.PostNl, E.PostNl, D.POSTNL, E.PostNl, D.Bpost, E.Bpost, D.BPOST, E.Bpost, D.CheapCargo, E.CheapCargo, D.CHEAP_CARGO, E.CheapCargo, D.Dpd, E.Dpd, D.DPD, E.Dpd, D.Instabox, E.Instabox, D.Dhl, E.Dhl, D.BolCom, E.Bol, D.Bol, E.Bol, D.BOL, E.Bol, D.Ups, E.Ups, D.DhlForYou, E.DhlForYou, D.DHL_FOR_YOU, E.DhlForYou, D.DhlParcelConnect, E.DhlParcelConnect, D.DHL_PARCEL_CONNECT, E.DhlParcelConnect, D.DhlEuroPlus, E.DhlEuroPlus, D.DHL_EUROPLUS, E.DhlEuroPlus, D.UpsStandard, E.UpsStandard, D.UPS_STANDARD, E.UpsStandard, D.UpsExpressSaver, E.UpsExpressSaver, D.UPS_EXPRESS_SAVER, E.UpsExpressSaver, D.Gls, E.Gls, D.GLS, E.Gls, D.Brt, E.Brt, D.BRT, E.Brt, D.Trunkrs, E.Trunkrs, D.TRUNKRS, E.Trunkrs, D.InPost, E.InPost, D.INPOST, E.InPost, D.PosteItaliane, E.PosteItaliane, D.POSTE_ITALIANE, E.PosteItaliane, D.Spring, E.Spring, D.SPRING, E.Spring, D.ViaTim, E.ViaTim, D.VIA_TIM, E.ViaTim, E.PostNl, E.Bpost, E.CheapCargo, E.Dpd, E.Instabox, E.Dhl, E.Bol, E.Ups, E.DhlForYou, E.DhlParcelConnect, E.DhlEuroPlus, E.UpsStandard, E.UpsExpressSaver, E.Gls, E.Brt, E.Trunkrs, E.InPost, E.PosteItaliane, E.ViaTim;
var O = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
O.Austria, O.Belgium, O.Bulgaria, O.Croatia, O.Cyprus, O.CzechRepublic, O.Denmark, O.Estonia, O.Finland, O.France, O.Germany, O.Greece, O.Hungary, O.Ireland, O.Italy, O.Latvia, O.Lithuania, O.Luxembourg, O.Malta, O.Netherlands, O.Poland, O.Portugal, O.Romania, O.Slovakia, O.Slovenia, O.Spain, O.Sweden, Object.values(O), O.Angola, O.AntiguaAndBarbuda, O.Aruba, O.Bahamas, O.Belize, O.Benin, O.Bermuda, O.BonaireSintEustatiusAndSaba, O.Botswana, O.BurkinaFaso, O.Burundi, O.Cameroon, O.CanaryIslands, O.CentralAfricanRepublic, O.Comoros, O.CongoBrazzaville, O.CongoKinshasa, O.CoteDIvoire, O.Curacao, O.Djibouti, O.Dominica, O.DutchAntilles, O.EquatorialGuinea, O.Eritrea, O.Fiji, O.Gabon, O.Gambia, O.Ghana, O.Grenada, O.Guyana, O.HongKong, O.Kiribati, O.KoreaPeoplesDemocraticRepublic, O.Macao, O.Malawi, O.Mali, O.Mauritania, O.Nauru, O.Qatar, O.Rwanda, O.SaintKittsAndNevis, O.SaoTomeAndPrincipe, O.Seychelles, O.SierraLeone, O.SintMaarten, O.Suriname, O.SyrianArabRepublic, O.TimorLeste, O.Togo, O.Tonga, O.Tuvalu, O.Uganda, O.UnitedArabEmirates, O.Vanuatu, O.Yemen, O.Zimbabwe, O.Austria, O.Belgium, O.Bulgaria, O.Croatia, O.CzechRepublic, O.Estonia, O.Finland, O.France, O.Germany, O.Greece, O.Hungary, O.Ireland, O.Italy, O.Latvia, O.Lithuania, O.Luxembourg, O.Malta, O.Netherlands, O.Portugal, O.Romania, O.Slovakia, O.Slovenia, O.Spain, O.UnitedKingdom, O.Denmark, O.Germany, O.Sweden;
var k = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, A = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, j = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
k.EarlyMorning, A.EarlyMorning, k.Morning, A.Morning, k.Standard, A.Standard, k.Evening, A.Evening, k.Pickup, A.Pickup, k.PickupExpress, A.PickupExpress, k.SameDayDelivery, A.SameDayDelivery, k.Express, A.Express, A.EarlyMorning, k.EarlyMorning, A.Morning, k.Morning, A.Standard, k.Standard, A.Evening, k.Evening, A.Pickup, k.Pickup, A.PickupExpress, k.PickupExpress, A.SameDayDelivery, k.SameDayDelivery, A.Express, k.Express, k.EarlyMorning, j.EarlyMorning, k.Morning, j.Morning, k.Standard, j.Standard, k.Evening, j.Evening, k.Pickup, j.Pickup, k.PickupExpress, j.PickupExpress, k.SameDayDelivery, j.SameDayDelivery, k.Express, j.Express, j.EarlyMorning, A.EarlyMorning, j.Morning, A.Morning, j.Standard, A.Standard, j.Evening, A.Evening, j.Pickup, A.Pickup, j.PickupExpress, A.PickupExpress, j.SameDayDelivery, A.SameDayDelivery, j.Express, A.Express, k.EarlyMorning, k.Morning, k.Standard, k.Evening, k.Pickup, k.PickupExpress, k.SameDayDelivery, k.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var M = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, N = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
N.Sunday, M.Sunday, N.Monday, M.Monday, N.Tuesday, M.Tuesday, N.Wednesday, M.Wednesday, N.Thursday, M.Thursday, N.Friday, M.Friday, N.Saturday, M.Saturday, M.Sunday, N.Sunday, M.Monday, N.Monday, M.Tuesday, N.Tuesday, M.Wednesday, N.Wednesday, M.Thursday, N.Thursday, M.Friday, N.Friday, M.Saturday, N.Saturday;
var _t = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
_t.Bytes, _t.Kilobytes, _t.Megabytes, _t.Gigabytes, _t.Terabytes;
var P = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, F = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
P.Bol, F.Bol, P.Exact, F.Exact, P.Amazon, F.Amazon, P.Wix, F.Wix, P.ExactDe, F.ExactDe, P.Etsy, F.Etsy, F.Bol, P.Bol, F.Exact, P.Exact, F.Amazon, P.Amazon, F.Wix, P.Wix, F.ExactDe, P.ExactDe, F.Etsy, P.Etsy;
var I = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, L = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
I.Unpaid, L.Unpaid, I.Due, L.Due, I.DuePrepayment, L.DuePrepayment, I.Reminder1, L.Reminder1, I.Reminder2, L.Reminder2, I.Dun, L.Dun, I.Collection, L.Collection, I.Instalments, L.Instalments, I.PaymentArrangement, L.PaymentArrangement, I.Dispute, L.Dispute, I.LegalProcedure, L.LegalProcedure, I.Insolvency, L.Insolvency, I.WriteOff, L.WriteOff, I.Pending, L.Pending, I.Cancelled, L.Cancelled, I.Paid, L.Paid, I.PaidOnline, L.PaidOnline, I.PaidAutomatic, L.PaidAutomatic, I.PaidCredit, L.PaidCredit, I.PaidZeroItems, L.PaidZeroItems, I.InvoiceWith0InvoiceItemsPaidZeroBalance, L.PaidZeroBalance, I.Due, I.Reminder1, I.Reminder2, I.Dun, I.Collection, I.Instalments, I.PaymentArrangement, I.Dispute, I.Paid, I.PaidOnline, I.PaidAutomatic, I.PaidCredit, I.PaidZeroItems;
var vt = {
	Gram: "g",
	Kilogram: "kg"
};
vt.Gram, vt.Kilogram;
var yt = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
yt.Millimeter, yt.Centimeter, yt.Meter;
var R = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, z = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
z.PendingConcept, z.PendingRegistered, z.EnRouteHandedToCarrier, z.EnRouteSorting, z.EnRouteDistribution, z.EnRouteCustoms, z.DeliveredReadyForPickup, z.DeliveredAtRecipient, z.DeliveredPackagePickedUp;
var B = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, V = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
V.Light, B.Light, V.Start, B.Start, V.Plus, B.Plus, V.Premium, B.Premium, V.Max, B.Max, B.Light, V.Light, B.Start, V.Start, B.Plus, V.Plus, B.Premium, V.Premium, B.Max, V.Max;
var H = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, U = {
	Start: B.Start,
	Plus: B.Plus,
	Premium: B.Premium,
	Max: B.Max
};
H.Start, U.Start, H.Plus, U.Plus, H.Premium, U.Premium, H.Max, U.Max, U.Start, H.Start, U.Plus, H.Plus, U.Premium, H.Premium, U.Max, H.Max;
var W = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, G = {
	Start: B.Start,
	Plus: B.Plus,
	Premium: B.Premium,
	Max: B.Max
};
W.Start, G.Start, W.Plus, G.Plus, W.Premium, G.Premium, W.Max, G.Max, G.Start, W.Start, G.Plus, W.Plus, G.Premium, W.Premium, G.Max, W.Max;
var K = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, q = {
	Light: B.Light,
	Start: B.Start,
	Plus: B.Plus,
	Premium: B.Premium,
	Max: B.Max
};
K.Light, q.Light, K.Start, q.Start, K.Plus, q.Plus, K.Premium, q.Premium, K.Max, q.Max, q.Light, K.Light, q.Start, K.Start, q.Plus, K.Plus, q.Premium, K.Premium, q.Max, K.Max;
var bt = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, xt = {
	Start: B.Start,
	Plus: B.Plus,
	Premium: B.Premium,
	Max: B.Max
};
bt.Start, xt.Start, bt.Plus, xt.Plus, bt.Premium, xt.Premium, bt.Max, xt.Max, xt.Start, bt.Start, xt.Plus, bt.Plus, xt.Premium, bt.Premium, xt.Max, bt.Max;
var J = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, St = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
J.MyParcel, St.MyParcel, J.Flespakket, St.Flespakket, J.SendMyParcel, St.SendMyParcel, J.MyParcelIt, St.MyParcelIt, J.DeliverDutch, St.DeliverDutch, J.PostNlPlugin, St.PostNlPlugin, J.MyParcel, Y.MyParcelNl, J.Flespakket, Y.MyParcelNl, J.SendMyParcel, Y.MyParcelBe, J.MyParcelIt, Y.MyParcelIt, J.DeliverDutch, Y.DeliverDutch, J.PostNlPlugin, Y.PostNlPlugin, Y.MyParcelNl, J.MyParcel, Y.MyParcelBe, J.SendMyParcel, Y.MyParcelIt, J.MyParcelIt, Y.MyParcelNl, R.HomeCountry, O.Netherlands, R.Eu, R.Row, O.Belgium, Y.MyParcelBe, R.HomeCountry, O.Belgium, O.Netherlands, R.Eu, R.Row, Y.MyParcelBe, R.HomeCountry, O.Belgium, R.Eu, R.Row, Y.MyParcelNl, R.HomeCountry, O.Netherlands, R.Eu, R.Row, Y.MyParcelNl, R.HomeCountry, O.Netherlands, O.Belgium, O.Luxembourg, E.Bpost, E.PostNl, E.DhlForYou, E.DhlParcelConnect, E.DhlEuroPlus, E.Ups, E.UpsStandard, E.UpsExpressSaver;
var X = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Z = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
X.Package, Z.Package, X.Mailbox, Z.Mailbox, X.Letter, Z.Letter, X.DigitalStamp, Z.DigitalStamp, X.Pallet, Z.Pallet, X.PackageSmall, Z.PackageSmall, X.Envelope, Z.Envelope, Z.Package, X.Package, Z.Mailbox, X.Mailbox, Z.Letter, X.Letter, Z.DigitalStamp, X.DigitalStamp, Z.Pallet, X.Pallet, Z.PackageSmall, X.PackageSmall, Z.Envelope, X.Envelope;
var Q = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
X.Package, Q.PACKAGE, X.Mailbox, Q.MAILBOX, X.Letter, Q.UNFRANKED, X.DigitalStamp, Q.DIGITAL_STAMP, X.Pallet, Q.PALLET, X.PackageSmall, Q.SMALL_PACKAGE, X.Envelope, Q.ENVELOPE, Q.PACKAGE, X.Package, Q.MAILBOX, X.Mailbox, Q.UNFRANKED, X.Letter, Q.DIGITAL_STAMP, X.DigitalStamp, Q.PALLET, X.Pallet, Q.SMALL_PACKAGE, X.PackageSmall, Q.ENVELOPE, X.Envelope, X.Package, X.Mailbox, X.Letter, X.DigitalStamp, X.Pallet, X.PackageSmall, X.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/fields/WeightSelectorField/WeightSelectorField.vue?vue&type=script&setup=true&lang.ts
var Ct = { class: "flex flex-col gap-y-2 grow" }, wt = /* @__PURE__ */ l({
	__name: "WeightSelectorField",
	props: {
		name: {},
		label: {},
		unitFieldLabel: {},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		placeholder: { default: "" },
		note: { default: void 0 },
		unit: { default: vt.Kilogram },
		units: {},
		emptyValue: { default: 0 }
	},
	emits: ["unit-changed", "blur"],
	setup(e, { emit: t }) {
		let r = e, i = t, { value: l, errorMessage: u, setValue: d, handleBlur: f } = C(() => r.name, void 0, { validateOnValueUpdate: !1 }), p = te(l.value), m = (e) => {
			i("blur", e), f(e, !0);
		};
		return ie(p, (e) => {
			e !== l.value && d(e ?? void 0, !1);
		}, { immediate: !0 }), ie(l, (e) => {
			e !== p.value && (p.value = e);
		}), (t, r) => (h(), n(v(b), { "hide-label": e.hideLabel }, o({
			default: y(() => [a("div", Ct, [c(v(Ce), {
				modelValue: p.value,
				"onUpdate:modelValue": r[0] ||= (e) => p.value = e,
				"aria-label": e.hideLabel ? e.label : void 0,
				"aria-labelledby": e.hideLabel ? void 0 : e.name,
				"empty-value": e.emptyValue,
				"is-valid": v(u) == null,
				label: e.label,
				name: e.name,
				placeholder: e.placeholder,
				unit: e.unit,
				"unit-field-label": e.unitFieldLabel,
				units: e.units,
				onBlur: r[1] ||= (e) => m(e),
				onUnitChanged: r[2] ||= (e) => i("unit-changed", e)
			}, null, 8, [
				"modelValue",
				"aria-label",
				"aria-labelledby",
				"empty-value",
				"is-valid",
				"label",
				"name",
				"placeholder",
				"unit",
				"unit-field-label",
				"units"
			]), g(t.$slots, "hint")])]),
			_: 2
		}, [
			e.hideLabel ? void 0 : {
				name: "label",
				fn: y(() => [c(v(x), { for: e.name }, o({
					default: y(() => [s(_(e.label) + " ", 1)]),
					_: 2
				}, [e.sublabel ? {
					name: "sublabel",
					fn: y(() => [s(_(e.sublabel), 1)]),
					key: "0"
				} : void 0]), 1032, ["for"])]),
				key: "0"
			},
			e.note ? {
				name: "note",
				fn: y(() => [c(v(S), null, {
					default: y(() => [s(_(e.note), 1)]),
					_: 1
				})]),
				key: "1"
			} : void 0,
			v(u) && v(u).trim() ? {
				name: "errors",
				fn: y(() => [c(T, null, {
					default: y(() => [s(_(v(u)), 1)]),
					_: 1
				})]),
				key: "2"
			} : void 0
		]), 1032, ["hide-label"]));
	}
});
//#endregion
//#region src/tests/veeFormWrapper.ts
function Tt(e, t, n) {
	return l({
		name: "TestFormWrapper",
		inheritAttrs: !1,
		components: { Field: e },
		setup(r, { attrs: i, emit: a, slots: o }) {
			/* c8 ignore start */
			m((e) => {
				console.error("Error captured in FormWrapper", e);
			});
			/* c8 ignore stop */
			let s = Te({
				validationSchema: n?.validationSchema,
				initialValues: n?.initialValues
			});
			/* c8 ignore next 3 */
			t && t(s);
			let c = {};
			try {
				e.emits?.forEach((e) => {
					c[e] = (...t) => a(e, ...t);
				});
			} catch (e) {
				console.error("Error setting up emits in FormWrapper:", e);
			}
			/* c8 ignore stop */
			return {
				attrs: i,
				newEvents: c,
				slots: o
			};
		},
		template: "\n      <form @submit.prevent=\"() => {}\">\n        <Field v-bind=\"attrs\" v-on=\"newEvents\" >\n          <template v-for=\"(_, name) in slots\" v-slot:[name]=\"slotProps\">\n            <slot v-if=\"slotProps\" :name=\"name\" v-bind=\"slotProps\" />\n            <slot v-else :name=\"name\" />\n          </template>\n        </Field>\n      </form>\n    "
	});
}
//#endregion
//#region src/utils/schema/schemaHelpers.ts
var Et = (e) => Oe.preprocess((e) => typeof e == "string" && e.trim() === "" ? void 0 : e, e), Dt = (e) => Oe.preprocess((e) => {
	if (e !== null) return typeof e == "string" && e.trim() === "" ? void 0 : e;
}, e), Ot = (e, t) => Oe.preprocess((t) => t ?? e, t), kt = (e, t) => e ? t : t.optional(), At = (e, t) => e.refine(t, { message: "" }), jt = (e) => typeof e == "string" ? e.trim() === "" ? void 0 : e : e && typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, t]) => [e, jt(t)])) : e, Mt = {
	handleEmptyAndNullAsUndefined: Dt,
	handleUndefinedAndNullAsValue: Ot,
	handleEmptyAsUndefined: Et,
	emptyStringsToUndefined: jt,
	requiredIf: kt,
	preprocessNestedSchema: (e) => Oe.preprocess(jt, e),
	zodAlwaysRefine: (e) => Oe.any().superRefine(async (t, n) => {
		let r = await e.safeParseAsync(t);
		if (r.success === !1) for (let e of r.error.issues) n.addIssue(e);
	}),
	refineWithoutMessage: At
}, Nt = { phone: (e) => Oe.string().regex(De.phone).or(Oe.literal("")).safeParse(e).success }, Pt = (e) => e.replace(/\[[^\]]*\]/g, "[]"), Ft = class {
	entries = {};
	field(e, t) {
		return this.entries[e] = t, this;
	}
	build() {
		let e = { ...this.entries }, t = (t) => {
			let n = Pt(t), r = e[n];
			return r ? typeof r == "function" ? r({ path: t }) : r : null;
		}, n = (e, n) => {
			let r = t(e);
			if (!r) {
				let t = e.lastIndexOf(".");
				return t === -1 ? e : e.slice(t + 1);
			}
			return typeof r == "string" ? n(r) : n(r.key, r.params ?? {});
		};
		return {
			getFieldLabel: n,
			formatErrorFields: (e, t) => {
				let r = Object.keys(e).map((e) => n(e, t));
				return [...new Set(r)].join(", ");
			}
		};
	}
}, It = {
	validation: Nt,
	schema: Mt
};
//#endregion
export { Ie as CheckboxField, Re as CheckboxGroupField, Be as CurrencyInputField, Ve as DateField, Ke as DimensionsField, Ye as FieldGroup, Ft as FieldLabelBuilder, Pe as Form, T as FormError, Ze as MultiSelectWithBadgesField, $e as NumberInputField, tt as RadioGroupField, rt as SearchSuggestTextInputField, at as SelectAutocompleteField, st as SelectField, lt as SwitchField, ut as TextAreaField, ft as TextInputField, mt as TextInputWithButtonField, gt as TextInputWithButtonFieldArray, wt as WeightSelectorField, It as utils, Tt as veeFormWrapper };
